export default __webpack_public_path__ + "static/media/jump@3x.ff82b0e6.png";